import { StateProps } from "./";

export function eqSet<T>(setA: Set<T>, setB: Set<T>) {
  // If sets are different sizes, return false early
  if (setA.size !== setB.size) return false;

  // If sets are the same size,
  // but setA contians something not in setB
  // return false
  for (const a of setA) if (!setB.has(a)) return false;

  // Otherwise, sets are equal
  return true;
}

export function calcIsAllSelected(
  projectSites: Insite.Site[] = [],
  selectedSites: Set<string> = new Set()
) {
  // If there aren't any sites in the project, projects are still loading in.
  if (projectSites.length === 0 || selectedSites.size === 0) return false;

  const selected: Set<string> = new Set(selectedSites);
  // isAllSelected if selectedSites contains all sites in activeProject
  return (
    projectSites.filter((s: Insite.Site) => selected.has(s.syncoId)).length ===
    projectSites.length
  );
}

export function selectAllSetState(
  projectSites: Insite.Site[],
  activeSites: string[]
) {
  return (state: StateProps) => {
    const { selectedSites, shouldFilter, matchingSites } = state;

    const filteredSites = projectSites.filter((s: Insite.Site) =>
      matchingSites.has(s.syncoId)
    );
    let clone = new Set(selectedSites);

    const isAllSelected = shouldFilter
      ? calcIsAllSelected(filteredSites, selectedSites)
      : calcIsAllSelected(projectSites, selectedSites);

    const siteIds = shouldFilter
      ? filteredSites.map((s) => s.syncoId)
      : projectSites.map((s) => s.syncoId);

    if (isAllSelected) {
      projectSites.forEach((s) => clone.delete(s.syncoId));
    } else {
      clone = new Set([...selectedSites, ...siteIds]);
    }

    const isPristine = eqSet(new Set(activeSites), clone);

    return {
      isAllSelected: !isAllSelected,
      isPristine,
      selectedSites: clone,
    };
  };
}

export function projectChangeSetState(
  activeSites: Insite.AppState["userSites"]["sites"]
) {
  return ({ selectedSites, shouldFilter, matchingSites }: StateProps) => {
    const sites = shouldFilter
      ? activeSites.filter((site: Insite.Site) =>
          matchingSites.has(site.syncoId)
        )
      : activeSites;
    const isAllSelected = calcIsAllSelected(sites, selectedSites);
    return {
      isAllSelected,
    };
  };
}
